intra_module.directive('currentactivities', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/widget/currentactivities/template.html',
		controller:  'CurrentActivitiesCtrl',
		replace:     true
	};
});
